// Servicios de Kiwi Dinámico: de aquí salen las tarjetas del inicio, el índice
// /servicios y cada página /servicios/:slug. Agregar un servicio = agregar un
// objeto aquí, su ruta en sitemap-paginas.txt y su título/descripción en
// config/seo-rutas.json (scripts/html-por-ruta.js falla si falta).
//
// Todas las páginas de servicio siguen la misma estructura (problema → qué
// hacemos → entregables → para quién → CTA) para que quien compare dos
// servicios encuentre cada cosa en el mismo lugar.
//
// Los textos describen trabajo que Kiwi ya hace hoy para clientes reales
// (redes MikroTik, Active Directory, respaldos de HANA, integraciones por
// Service Layer, aplicaciones Node/React). Antes de prometer algo nuevo aquí,
// confirmarlo con Adán.

export const servicios = [
  {
    slug: 'soporte-ti',
    icono: 'soporte',
    titulo: 'Soporte y administración de TI',
    corto: 'Soporte de TI',
    beneficio: 'Sus computadoras, servidores y usuarios en orden, con alguien que responde cuando algo falla.',
    problema: {
      titulo: 'Cuando algo falla, nadie sabe a quién llamar',
      texto: [
        'La clave del correo que nadie recuerda, la impresora que dejó de imprimir, el servidor que se llenó un viernes en la tarde. En muchas pymes la tecnología la resuelve «el que sabe un poco», entre otras cien tareas.',
        'Y los respaldos se dan por hechos hasta el día en que hacen falta.',
      ],
    },
    hacemos: [
      'Soporte remoto y en sitio para computadoras, impresoras y teléfonos de la empresa.',
      'Usuarios, permisos y políticas centralizadas (Active Directory), para que entrar y salir de la empresa no dependa de una persona.',
      'Respaldos con prueba de restauración, no solo con la tarea programada.',
      'Actualizaciones, antivirus y revisión de accesos para cerrar los huecos más comunes.',
      'Correo y Microsoft 365: cuentas, buzones compartidos y traslados de correo.',
    ],
    entregables: [
      'Inventario de equipos, usuarios y accesos de la empresa.',
      'Plan de respaldos con la última prueba de restauración documentada.',
      'Informe de hallazgos con prioridades: qué arreglar primero y por qué.',
      'Bitácora de cada cambio que hacemos en sus sistemas.',
    ],
    paraQuien:
      'Empresas sin departamento de TI propio, o con una persona de sistemas que necesita respaldo para lo que no le da el tiempo.',
    mensaje: 'Hola, me interesa el soporte y la administración de TI para mi empresa.',
    cta: 'Deje el soporte de TI en nuestras manos.',
  },
  {
    slug: 'desarrollo-a-medida',
    icono: 'codigo',
    titulo: 'Desarrollo de software a medida',
    corto: 'Software a medida',
    beneficio: 'Aplicaciones web y móviles para el proceso que ninguna herramienta resuelve bien.',
    problema: {
      titulo: 'El proceso vive en Excel, WhatsApp y papel',
      texto: [
        'Pedidos que se copian de un chat a una hoja, reportes que alguien arma a mano cada lunes, datos que se digitan dos veces en dos sistemas que no se hablan.',
        'Funciona, hasta que la persona que lo sostiene se va de vacaciones.',
      ],
    },
    hacemos: [
      'Aplicaciones web y apps instalables en el teléfono para su equipo o sus clientes.',
      'Integraciones entre sistemas: SAP Business One, facturación electrónica, correo y WhatsApp.',
      'Tableros y reportes que se actualizan solos con los datos de su sistema.',
      'Automatización de tareas repetitivas: alertas, envíos programados y conciliaciones.',
    ],
    entregables: [
      'Alcance, plazo y costo por escrito antes de empezar.',
      'Un prototipo navegable para validar la idea antes de construirla.',
      'Entregas por etapas que su equipo prueba con datos reales.',
      'Documentación y soporte después de salir a producción.',
    ],
    paraQuien:
      'Empresas que ya probaron herramientas genéricas y siguen con un proceso a mano, o que necesitan que dos sistemas se hablen.',
    mensaje: 'Hola, tengo un proceso en mi empresa que quisiera convertir en una aplicación.',
    cta: 'Cuéntenos el proceso que quiere ordenar.',
  },
  {
    slug: 'infraestructura-redes',
    icono: 'red',
    titulo: 'Infraestructura y redes',
    corto: 'Infraestructura y redes',
    beneficio: 'Red, Wi-Fi, servidores y VPN entre sucursales que aguantan el día a día.',
    problema: {
      titulo: 'La red se cae y nadie sabe por qué',
      texto: [
        'Sucursales que no ven el sistema central, una VPN que hay que reiniciar todos los días, un servidor viejo del que ya no hay repuestos y un rack que nadie se atreve a tocar.',
        'Cada caída para la facturación, el inventario y la atención al cliente.',
      ],
    },
    hacemos: [
      'Diseño y configuración de redes y Wi-Fi para oficinas, bodegas y tiendas.',
      'VPN entre sucursales y para teletrabajo, con usuarios de la empresa.',
      'Servidores y virtualización (Hyper-V), almacenamiento y respaldos fuera del sitio.',
      'Migraciones a la nube cuando tienen sentido: correo, archivos y servidores.',
    ],
    entregables: [
      'Diagrama de la red actualizado, con direcciones y equipos.',
      'Respaldo de la configuración de cada equipo de red.',
      'Pruebas documentadas de VPN, respaldos y conmutación por falla.',
      'Recomendaciones de compra justificadas, sin atarlo a una marca.',
    ],
    paraQuien:
      'Empresas con varias sedes, bodegas o tiendas, y oficinas cuyo crecimiento ya rebasó la red que se armó al principio.',
    mensaje: 'Hola, quisiera que revisen la red y los servidores de mi empresa.',
    cta: 'Revisemos su red antes de la próxima caída.',
  },
  {
    slug: 'sap-business-one',
    icono: 'datos',
    titulo: 'SAP Business One y SAP HANA',
    corto: 'SAP Business One',
    beneficio: 'Reportes, integraciones y ajustes para sacarle más al SAP que ya tiene.',
    problema: {
      titulo: 'El SAP hace lo básico; el resto sale de Excel',
      texto: [
        'Los reportes de márgenes, cobros o inventario se arman exportando a Excel. Las alertas no llegan, los formatos de impresión no dicen lo que el cliente necesita y otro sistema de la empresa no se conecta.',
        'El servidor HANA, mientras tanto, crece sin que nadie revise sus respaldos.',
      ],
    },
    hacemos: [
      'Consultas, vistas y reportes sobre SAP HANA o SQL Server.',
      'Integraciones con otros sistemas por Service Layer.',
      'Formatos de impresión, campos de usuario y automatizaciones dentro de SAP.',
      'Mantenimiento del servidor: respaldos, espacio, certificados y actualizaciones.',
    ],
    entregables: [
      'Reportes y tableros con los datos vivos de SAP, no con exportaciones.',
      'Integraciones documentadas, con registro de errores.',
      'Rutina de respaldos del servidor con aviso por correo.',
      'Un informe del estado del servidor y lo que conviene atender.',
    ],
    paraQuien:
      'Empresas que ya usan SAP Business One. No vendemos licencias de SAP: trabajamos sobre la instalación que ya tiene.',
    mensaje: 'Hola, usamos SAP Business One y necesitamos apoyo con reportes o integraciones.',
    cta: 'Saquémosle más a su SAP Business One.',
  },
];

// Las seis líneas que se muestran en el inicio y en /servicios. Kiwi ERP y
// Licencias tienen su propia página, por eso van aparte y con `href`.
export const lineasDeServicio = [
  ...servicios.map((s) => ({ icono: s.icono, titulo: s.titulo, beneficio: s.beneficio, to: `/servicios/${s.slug}` })),
  {
    icono: 'factura',
    titulo: 'Facturación electrónica con Kiwi ERP',
    beneficio: 'Factura electrónica 4.4 e inventario en línea, con la base gratis.',
    // Página estática aparte (public/erp/): se enlaza con <a>, no con <Link>.
    href: '/erp/',
  },
  {
    icono: 'licencia',
    titulo: 'Licencias Microsoft',
    beneficio: 'Microsoft 365, Windows y SQL Server originales, instalados y configurados.',
    to: '/licencias',
  },
];

export const servicioPorSlug = (slug) => servicios.find((s) => s.slug === slug);
